import { render, staticRenderFns } from "./AddOrder.vue?vue&type=template&id=098e46f0"
import script from "./AddOrder.vue?vue&type=script&lang=ts"
export * from "./AddOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports